<template>
  <CockpitDialog
    :title="title"
    left="630px"
    width="890px"
    height="550px"
    top="120px"
    @close="$emit('close')"
  >
    <el-form :model="formData" class="h-full w-full">
      <el-row :gutter="15" class="w-full h-full overflow-auto">
        <el-col v-for="(item, index) in formConfig" :key="index" :span="item.col || 24">
          <el-form-item
            :label="item.label ? `${item.label} : ` : ''"
            :label-width="item.labelWidth ? `${item.labelWidth}px` : item.label ? '185px' : '0px'"
          >
            <template v-if="item.type === 'dividingLine'">
              <descriptionTitle :title="item.prop" />
            </template>
            <template v-else-if="item.type === 'attachment'">
              <el-upload
                v-if="formData[item.prop]"
                disabled
                action=""
                :on-preview="download"
                :file-list="dealFileList(formData[item.prop])"
              >
              </el-upload>
              <div v-else class="text-hex-ccc">暂未上传附件</div>
            </template>
            <div v-else-if="item.type === 'dataCategory'" class="text-hex-ccc">
              {{ item.dataCategory[Number(formData[item.prop])] }}
            </div>
            <div v-else-if="item.type === 'double'" class="flex text-hex-ccc">
              <div class="w-30px text-center">
                <span v-if="formData[item.leftProp]">{{ formData[item.leftProp] }}</span>
                <span v-else>--</span>
              </div>
              <div class="w-30px text-center">x</div>
              <div class="w-30px text-center">
                <span v-if="formData[item.rightProp]">{{ formData[item.rightProp] }}</span>
                <span v-else>--</span>
              </div>
            </div>
            <div v-else class="text-hex-ccc">
              <template v-if="formData[item.prop]">
                <div class="truncate">{{ formData[item.prop] }}</div>
              </template>

              <span v-else>暂无数据</span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import descriptionTitle from '@/modules/visualization-cockpit/components/business/metalComponents/DescriptionTitle'
import { metalBimDetailConfig } from './config'

export default {
  data() {
    return {
      formConfig: {},
    }
  },
  methods: {
    download(file) {
      const metalUrl = _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["visualization-cockpit"].config.metalUrl'
      )
      window.location.href = `${metalUrl}${file.url}`
    },
    dealFileList(val) {
      if (val) {
        // 判断多个附件(,) 还是单个附件 返回字段包含 ','
        const multipleAttachments = _.includes(val, ',')
        if (multipleAttachments) {
          const multipleArr = _.split(val, ',')
          return _.map(multipleArr, (item) => {
            return {
              name: _.split(item, 'name=').pop(),
              url: item,
            }
          })
        }
        return new Array({ name: _.split(val, 'name=').pop(), url: val })
      }
      return []
    },
  },
  components: {
    CockpitDialog,
    descriptionTitle,
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // 默认管道基础台账
    type: {
      type: String,
      default: 'pipelineFoundationLedger',
    },
    bimDetail: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formData() {
      return this.bimDetail
    },
  },
  created() {},
  watch: {
    bimDetail: {
      handler() {
        this.formConfig = metalBimDetailConfig[this.type]
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-upload {
  display: none !important;
}
::v-deep .el-upload-list__item:hover {
  background-color: transparent !important;
}
::v-deep .el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: #00ffcf;
}
::v-deep .el-upload-list__item .el-icon-upload-success {
  color: #47c1aa;
}
::v-deep .el-upload-list__item-name {
  color: #47c1aa;
}
::v-deep .el-form-item {
  margin-bottom: 0px;
}
</style>
